"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Origin = exports.EntitySubType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["MENU"] = "menu";
    EntityType["SECTION"] = "section";
    EntityType["PRODUCT"] = "product";
    EntityType["COMPOSITE_PRODUCT"] = "composite_product";
    EntityType["CHOICE"] = "choice";
    EntityType["OPTION"] = "option";
    EntityType["PICKER"] = "picker";
})(EntityType || (exports.EntityType = EntityType = {}));
var EntitySubType;
(function (EntitySubType) {
    EntitySubType["SIZE"] = "size";
    EntitySubType["PICKER_OPTION"] = "picker_option";
})(EntitySubType || (exports.EntitySubType = EntitySubType = {}));
var Origin;
(function (Origin) {
    Origin["MANUAL"] = "manual";
    Origin["SYSTEM"] = "system";
})(Origin || (exports.Origin = Origin = {}));
//# sourceMappingURL=menu.js.map